<!--
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: zhaohaozhuang
 * @LastEditTime: 2022-12-29 17:23:26
 * @Description:
 -->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <xm-spin fix v-show="spin.show">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10" />
      </svg>
    </xm-spin>
    <xm-alert :show="modalInfo.alert" :title="modalInfo.title" :message="modalInfo.message" :on-ok="onOk"></xm-alert>
    <xm-confirm
      :show="modalInfo.confirm"
      :title="modalInfo.title"
      :okText="modalInfo.okText"
      :cancelText="modalInfo.cancleText"
      :message="modalInfo.message"
      :on-ok="onOk"
      :on-cancel="onCancel"
      :showCancle="modalInfo.showCancle"
    ></xm-confirm>
    <xm-under-enter
      :show="underEnter.show"
      :title="underEnter.title"
      :okText="underEnter.okText"
      :cancleText="underEnter.cancleText"
      :onOk="UnderEnterOnOk"
      :onCancle="UnderEnterOnCancle"
    ></xm-under-enter>
    <!-- 纪念册浮窗广告 -->
    <DraggableComponent :ShowType="ShowType" v-if="$route.path!='/artExhibition'" @showRight="showRight" />
    <ProtocolModal :show="protocolShow" @ok="onProtocolOk" @cancel="onProtocolCancel" />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import UserService from '@/service/UserService';
import User from './core/user';
import ProtocolModal from '@/module/common/ProtocolModal.vue';
import DraggableComponent from '@/module/DraggableComponent/index.vue';

const VersionEnum = ['STANDARD', 'ADVANCED', 'ULTIMATE', 'CHAIN'];
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    ProtocolModal,
    DraggableComponent,
  },
  methods: {
    ...mapActions(['onOk', 'onCancel', 'UnderEnterOnOk', 'UnderEnterOnCancle']),
    onProtocolCancel() {
      this.protocolShow = false;
    },
    showRight() {
      this.ShowType = true;
    },
    onProtocolOk() {
      this.protocolShow = false;
      localStorage.setItem('app_protocol', Date.now());
      try {
        // fromBrandMiniapp 是判断从专属小程序进来的
        // insure 是判断教培保险
        if (
          User.token() &&
          !window.userConfig.hasBindPhone &&
          router.history.current.meta.logined &&
          window.location.hash.indexOf('/wxPanelEntry/jump') == -1 &&
          window.location.href.indexOf('fromBrandMiniapp') == -1 &&
          window.location.href.indexOf('insure') == -1
          // && window.location.href.indexOf('/mine/points') == -1
        ) {
          console.log('跳转登录测试点2');
          window.router.replace({
            name: 'login',
          });
          return;
        }

        if (User.logined() && User.uid() && router.history.current.meta.logined) {
          UserService.getAttentionInsts().then(res => {
            window.saveUserInsts(res.data);
          });
        }
        logger.push('platform', 'mc');
        logger.push('event', '活跃度');
        logger.push('device', navigator.userAgent);
        logger.push('uid', User.uid());
        logger.logger();
      } catch (error) {}

      const initHeight = document.body.scrollHeight;
      window.addEventListener('resize', () => {
        if (document.body.scrollHeight < initHeight) {
          document.body.style.height = initHeight;
        }
      });
      window.addEventListener('popstate', function(e) {}, false);
      window.NewVersion = true;
    },
  },
  computed: {
    ...mapState({
      modalInfo: state => state.modal.info,
    }),
    ...mapGetters({
      spin: 'getSpinState',
    }),
    ...mapGetters({
      underEnter: 'getUnderEnterState',
    }),
  },
  created() {
    if (User.token() && !localStorage.getItem('app_protocol') && !sessionStorage.getItem('brandMiniapp') && window.location.href.indexOf('insure') == -1) {
      this.protocolShow = true;
    }
    wx.getNetworkType({
      success: res => {
        let type = res.networkType;
        if (type == 'wifi') {
          console.log('家长端使用wifi登录成功');
          window.traceLog('C_BIND_STUDENT_LOGIN_CODE_WIFI', '家长端使用wifi登录成功');
        } else {
          console.log('家长端使用数据流量登录成功（1G、2G、3G、4G、5G）');
          window.traceLog('C_BIND_STUDENT_LOGIN_CODE_FLOW', '家长端使用数据流量登录成功（1G、2G、3G、4G、5G）');
        }
      },
    });
    if (!this.ShowType) {
      this.ShowType = !!window.CK.getCookie('album-operate-tip');
    }
    console.log(window.location, 'xxxxxxxxxxxxx');
    console.log(this.$route, 'mmmmmmmmmmmmmmmm');
    window.traceLog('C_BIND_STUDENT_LOGIN_CODE', 'C端验证码登录成功');
  },

  data() {
    return {
      protocolShow: false,
      ShowType: false,
    };
  },
};
</script>

<style lang="less">
@import './core/style.less';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue